import React from 'react';
import '../../styles/SharedCinematic.css';
import { profile } from '../../content/portfolioData';
import RepelText from '../UI/RepelText';

const ContactCinematic = () => {
  const contactLinks = [
    {
      href: `mailto:${profile.email}`,
      label: profile.email,
      title: 'Email',
      icon: (
        <>
          <path
            d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M22 6L12 13L2 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
      svgFill: 'none',
    },
    {
      href: profile.linkedin,
      label: 'linkedin.com/in/waris-rawa',
      title: 'LinkedIn',
      external: true,
      icon: (
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      ),
      svgFill: 'currentColor',
    },
    {
      href: profile.github,
      label: 'github.com/technolity',
      title: 'GitHub',
      external: true,
      icon: (
        <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
      ),
      svgFill: 'currentColor',
    },
    {
      href: profile.x,
      label: 'x.com/technolity_',
      title: 'X',
      external: true,
      icon: (
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      ),
      svgFill: 'currentColor',
    },
  ];

  return (
    <section id="contact" className="section cinematic-section contact-section">
      <div className="container">
        <div className="section-header-cinematic">
          <span className="section-number">07</span>
          <RepelText as="h2" className="section-title-cinematic">Contact</RepelText>
          <div className="section-line" />
        </div>

        <div className="contact-content">
          <div className="contact-text">
            <h3 className="contact-tagline">
              <RepelText>Open to backend-heavy</RepelText>
              <br />
              <RepelText>SaaS and automation work.</RepelText>
            </h3>
            <RepelText as="p" className="contact-description">
              If you are building a product that needs clean data models, dependable integrations,
              and fast iteration without backend chaos, I am available for freelance and contract work.
            </RepelText>
            <RepelText as="span" className="contact-location">{profile.location}</RepelText>
          </div>

          <div className="contact-methods">
            {contactLinks.map((item) => (
              <a
                key={item.title}
                href={item.href}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noopener noreferrer' : undefined}
                className="contact-link"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill={item.svgFill}
                  aria-hidden="true"
                >
                  {item.icon}
                </svg>
                <div className="contact-link-copy">
                  <RepelText as="strong">{item.title}</RepelText>
                  <RepelText as="span">{item.label}</RepelText>
                </div>
              </a>
            ))}
          </div>

          <div className="contact-cta">
            <a className="btn-primary" href={profile.resume} download>
              <span>Download Resume →</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCinematic;
